import React from 'react'
import { useLocation } from 'react-router-dom'
// import { useTheme } from 'styled-components'
import { RightTop } from './RightTop'
import { RightCenter } from './RightCenter'
import { CopyrightNotice } from '../Home/CopyrightNotice'
import { useConfig } from '../../contexts/ConfigContext';

import {
  RightContainer,
  RightWrapper
} from './styles'

export const RightMain = ({ searchIconShowed, searchProducts, isProductSearched }) => {
  const location = useLocation()
  const isHomePage = location.pathname === '/' || location.pathname === '/home'
  const [configState] = useConfig()
  //debugger
  // const theme = useTheme();
  const bgImage = configState?.configs?.background_image;

  return (
    <RightContainer bgimage={bgImage} id="rightContainer">
      <RightWrapper>
        <RightTop search={searchProducts} searchIconShowed={searchIconShowed && !isProductSearched} />
        <RightCenter />
        {isHomePage && <CopyrightNotice variant="desktop" />}
      </RightWrapper>
    </RightContainer>
  )
}
